import { TPoint } from '../points.model';

export function isPointFlagged(point: TPoint): boolean {
  return point.flagged || false;
}
